import { useTranslation } from 'react-i18next';
import { errorCode } from '../personnel/source.js';

/**
 * Vessel Certificates hatalarının metni (`vesselCertificates.errors.<KOD>`; ADR 0029 D15): kod
 * dilde yoksa genel ileti. Alan hataları `fieldErrors`'tan, yoksa uç hatalarından.
 */
export function useCertificateErrorText() {
  const { t } = useTranslation();
  return (error: unknown) =>
    t(`vesselCertificates.errors.${errorCode(error)}`, {
      defaultValue: t('vesselCertificates.errors.GENERIC'),
    });
}

export function useFieldErrorText() {
  const { t } = useTranslation();
  return (code: string | undefined) =>
    code
      ? t(`vesselCertificates.fieldErrors.${code}`, {
          defaultValue: t(`vesselCertificates.errors.${code}`, {
            defaultValue: t('vesselCertificates.errors.VALIDATION_FAILED'),
          }),
        })
      : undefined;
}
